import { Box, Colors, InfoDot, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import MoneyWithCurrency, { isCurrency } from 'modules/core/lib/money'

import {
  formatProjectHours,
  getMinutesFromDecimalHours,
} from 'modules/project_management/lib/formatHours'

export interface CommonInsightProps {
  id: 'registered_cost' | 'registered_hours'
  title: string
  startingValue: number | undefined
  endingValue: number | undefined
  color: Colors
}

export interface CostInsightProps extends CommonInsightProps {
  id: 'registered_cost'
  currency: string
}

export interface HoursInsightProps extends CommonInsightProps {
  id: 'registered_hours'
}

export type ChartInsightProps = CostInsightProps | HoursInsightProps

export const ChartInsight: React.FC<ChartInsightProps> = (props) => {
  const {
    access: { locale: accessLocale },
  } = useCurrentSession()
  const { id, title, startingValue, endingValue, color } = props

  const dotLegend = (dotColor: Colors, legendLabel: string) => {
    return (
      <Box flexDirection="row" alignItems="center" gap="s6">
        <InfoDot size="medium" color={dotColor} />
        <Text color="grey1000" size="500" weight="semibold" whiteSpace="nowrap">
          {legendLabel}
        </Text>
      </Box>
    )
  }

  const getLegendLabel = (value: number, locale: string): string => {
    switch (id) {
      case 'registered_hours':
        return formatProjectHours(getMinutesFromDecimalHours(value))
      case 'registered_cost':
        if (isCurrency(props.currency)) {
          return MoneyWithCurrency({
            optionalDecimals: true,
            amount: Math.round(value * 10000) / 100,
            currency: props.currency,
            locale,
          })
        } else {
          return '-'
        }
    }
  }

  if (startingValue !== undefined && endingValue !== undefined) {
    const currentPeriodProgress = endingValue - startingValue
    const legend = getLegendLabel(currentPeriodProgress, accessLocale)

    return (
      <>
        <Text color="grey1000" size="300" ellipsis whiteSpace="nowrap">
          {title}
        </Text>
        {dotLegend(color, legend)}
      </>
    )
  }

  return (
    <>
      <Text color="grey1000" size="300" ellipsis whiteSpace="nowrap">
        {title}
      </Text>
      {dotLegend(color, '-')}
    </>
  )
}
